import { render, staticRenderFns } from "./communityList.vue?vue&type=template&id=6f174bb7"
import script from "./communityList.vue?vue&type=script&lang=js"
export * from "./communityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports